import { ReactElement, useState } from 'react';
import { Avatar, Button, Col, Row } from 'antd';
import { Spacer } from 'components/Spacer/Spacer';
import { CoreUtils } from 'utils/CoreUtils';
import { Link } from 'react-router-dom';
import { Globals } from 'constants/Globals';
import { Label } from 'components/Label/Label';
import { QueryHeader } from '@methodset/endpoint-client-ts';
import './QueryView.less';

export type SelectCallback = (header: QueryHeader) => void;

export type QueryViewProps = {
    index?: number,
    header: QueryHeader,
    onSelect: SelectCallback
} & typeof defaultProps;

const defaultProps = {
    index: 0
}

export const QueryView = (props: QueryViewProps): ReactElement => {

    const [show, setShow] = useState<boolean>(false);

    const handleMoreToggle = () => {
        setShow(!show);
    }

    const handleQuerySelect = () => {
        props.onSelect(props.header);
    }

    const buildSummary = (): string => {
        const description = props.header.description;
        if (!description) {
            return "<no description>";
        }
        const index = description.indexOf(".");
        return index == -1 ? description : description.substring(0, index + 1);
    }

    const buildLogo = (): string => {
        return props.header.name[0];
    }

    const color = Globals.BOLD_COLORS[props.index % Globals.BOLD_COLORS.length];
    const summary = buildSummary();
    const logo = buildLogo();
    return (
        <div className="x-queryview">
            <Row>
                <Spacer direction="vertical" size="sm">
                    <div className="x-queryview-wrap">
                        <Spacer alignment="top">
                            <div>
                                <Avatar
                                    size={40}
                                    shape="square"
                                    style={{ color: "white", backgroundColor: color }}
                                >
                                    {logo}
                                </Avatar>
                            </div>
                            <div>
                                <div className="x-queryview-name">{props.header.name}</div>
                                <div className="x-queryview-publisher">{props.header.provider ? props.header.provider : props.header.publisher}</div>
                                {/* <div className="x-queryview-publisher">{props.query.provider ?? props.header.publisher}</div> */}
                            </div>
                        </Spacer>
                        <div className="x-queryview-description">
                            {!show && <div className="x-queryview-summary">{summary}</div>}
                            {show && <div>{props.header.description}</div>}
                        </div>
                        <Link to="#" onClick={() => handleMoreToggle()}>{show ? "Show less" : "Show more"}</Link>
                    </div>
                </Spacer>
            </Row>
            <Row justify="space-between" align="bottom">
                <Col>
                    <Label label="Version">{CoreUtils.toVersion(props.header.version)}</Label>
                    <Label label="Publisher">{props.header.publisher ?? "Unpublished"}</Label>
                    <Label label="Updated">{CoreUtils.toTime(props.header.updateTime)}</Label>
                </Col>
                <Col>
                    <Button onClick={() => handleQuerySelect()}>
                        Select
                    </Button>
                </Col>
            </Row>
        </div>
    )
}

QueryView.defaultProps = defaultProps;
